import { render, staticRenderFns } from "./order-payment-dialog.vue?vue&type=template&id=02a08f54&scoped=true"
import script from "./order-payment-dialog.vue?vue&type=script&lang=js"
export * from "./order-payment-dialog.vue?vue&type=script&lang=js"
import style0 from "./order-payment-dialog.vue?vue&type=style&index=0&id=02a08f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a08f54",
  null
  
)

export default component.exports